"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dynamic = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useSfraApi = _interopRequireDefault(require("../../hooks/useSfraApi"));
var _hooks = require("../../pwa-kit/hooks");
var _useDynamicComponents = require("../../hooks/useDynamicComponents");
const _excluded = ["component", "className", "index", "isTopLevelComponent", "banners"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const BlacklistedComponents = ['pwa.anchor'];
const Dynamic = _ref => {
  let {
      component,
      className,
      index,
      isTopLevelComponent = false,
      banners
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    pages
  } = (0, _useSfraApi.default)();
  const {
    ContentCardBanner
  } = (0, _useDynamicComponents.useDynamicComponents)();
  const componentMapping = pages === null || pages === void 0 ? void 0 : pages.getComponentMapping();
  const pageDesignerEditMode = (0, _hooks.usePageDesignerEditMode)();
  if (componentMapping && typeof componentMapping[component.type_id] !== 'undefined') {
    const dynamicComponent = /*#__PURE__*/_react.default.createElement(componentMapping[component.type_id], _objectSpread({
      data: component.data,
      regions: component.regions,
      custom: component.custom,
      index,
      className: component.className || '',
      componentID: component.id
    }, rest));
    let content = dynamicComponent;
    if (banners && ContentCardBanner) {
      const bannersTop = banners === null || banners === void 0 ? void 0 : banners.filter(banner => {
        var _banner$extras;
        return ((_banner$extras = banner.extras) === null || _banner$extras === void 0 ? void 0 : _banner$extras.anchor_position) === 'top';
      });
      const bannersBottom = banners === null || banners === void 0 ? void 0 : banners.filter(banner => {
        var _banner$extras2;
        return ((_banner$extras2 = banner.extras) === null || _banner$extras2 === void 0 ? void 0 : _banner$extras2.anchor_position) === 'bottom';
      });
      const bannersReplace = banners === null || banners === void 0 ? void 0 : banners.filter(banner => {
        var _banner$extras3;
        return ((_banner$extras3 = banner.extras) === null || _banner$extras3 === void 0 ? void 0 : _banner$extras3.anchor_position) === 'replace';
      });
      content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, bannersTop && bannersTop.length > 0 && /*#__PURE__*/_react.default.createElement(ContentCardBanner, {
        cards: bannersTop
      }), bannersReplace && bannersReplace.length > 0 ? /*#__PURE__*/_react.default.createElement(ContentCardBanner, {
        cards: bannersReplace
      }) : dynamicComponent, bannersBottom && bannersBottom.length > 0 && /*#__PURE__*/_react.default.createElement(ContentCardBanner, {
        cards: bannersBottom
      }));
    }
    if (pageDesignerEditMode && isTopLevelComponent && !BlacklistedComponents.includes(component.type_id)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 50,
          cursor: 'pointer',
          padding: '4px 8px',
          backgroundColor: 'black',
          borderRadius: '4px',
          opacity: 0.1,
          display: 'inline-flex',
          alignItems: 'center',
          color: 'white',
          fontSize: '12px',
          userSelect: 'none'
        },
        onMouseEnter: e => e.currentTarget.style.opacity = '0.7',
        onMouseLeave: e => e.currentTarget.style.opacity = '0.1'
      }, /*#__PURE__*/_react.default.createElement("span", null, `${component.type_id} - `), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          userSelect: 'text'
        }
      }, component.id)), content);
    } else {
      return content;
    }
  }
  return /*#__PURE__*/_react.default.createElement(() => /*#__PURE__*/_react.default.createElement("div", null, "The component ", component.type_id, " has not been created yet."));
};
exports.Dynamic = Dynamic;